var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategorySearchWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1047",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 20V12.7692H9.73075V20H2.5ZM4 18.5H8.23075V14.2692H4V18.5ZM6.30775 9.49998L11.1155 1.61548L15.923 9.49998H6.30775ZM8.95375 7.99998H13.277L11.1155 4.52298L8.95375 7.99998ZM21.5943 22.3922L18.9635 19.7615C18.6327 20.0011 18.2695 20.1841 17.874 20.3105C17.4785 20.4368 17.059 20.5 16.6155 20.5C15.468 20.5 14.4953 20.1009 13.6973 19.3027C12.8991 18.5047 12.5 17.532 12.5 16.3845C12.5 15.2371 12.8991 14.2644 13.6973 13.4662C14.4953 12.6682 15.468 12.2692 16.6155 12.2692C17.7628 12.2692 18.7356 12.6682 19.5338 13.4662C20.3318 14.2644 20.7308 15.2371 20.7308 16.3845C20.7308 16.8178 20.6676 17.2306 20.5413 17.623C20.4151 18.0153 20.2404 18.3769 20.0173 18.7077L22.648 21.3385L21.5943 22.3922ZM16.615 19C17.3473 19 17.9664 18.7471 18.4723 18.2415C18.9779 17.736 19.2308 17.1171 19.2308 16.385C19.2308 15.6526 18.978 15.0336 18.4725 14.5277C17.9668 14.0221 17.3479 13.7692 16.6158 13.7692C15.8834 13.7692 15.2644 14.022 14.7588 14.5275C14.2529 15.0331 14 15.6521 14 16.3842C14 17.1166 14.2528 17.7356 14.7585 18.2412C15.264 18.7471 15.8828 19 16.615 19Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategorySearchWhite);
export default __webpack_public_path__ + "static/media/category_search-white.41ec8fab8303685b81e82fe54ae081c8.svg";
export { ForwardRef as ReactComponent };